import { axios } from '@/utils/request'

const api = {
    saiquList: '/adminapi/ability/saiquList',
    sjsqOptions: '/adminapi/ability/sjsqOptions',

    saiquDetail: '/adminapi/ability/saiquDetail',
    editSaiqu: '/adminapi/ability/editSaiqu',
    addSaiqu: '/adminapi/ability/addSaiqu',

    saijiList: '/adminapi/ability/saijiList',
    saijiDetail: '/adminapi/ability/saijiDetail',
    editSaiji: '/adminapi/ability/editSaiji',
    addSaiji: '/adminapi/ability/addSaiji',

    applyList: '/adminapi/ability/applyList',
    applyDetail: '/adminapi/ability/applyDetail',
    editApply: '/adminapi/ability/editApply',
    deleteApply: '/adminapi/ability/deleteApply',

    applyMemberList: '/adminapi/ability/applyMemberList',
    applyMemberDetail: '/adminapi/ability/applyMemberDetail',
    editApplyMember: '/adminapi/ability/editApplyMember',
    editApplyMemberScore: '/adminapi/ability/editApplyMemberScore',
    deleteApplyMember: '/adminapi/ability/deleteApplyMember',
    scoreImport: '/adminapi/ability/scoreImport',
}

export default api

export function getSaijiList(parameter) {
  return axios({
    url: api.saijiList,
    method: 'get',
    params: parameter
  })
}

export function getSaijiDetail(parameter) {
  return axios({
    url: api.saijiDetail,
    method: 'get',
    params: parameter
  })
}

export function addSaiji(parameter) {
  return axios({
    url: api.addSaiji,
    method: 'post',
    data: parameter
  })
}
export function editSaiji(parameter) {
  return axios({
    url: api.editSaiji,
    method: 'post',
    data: parameter
  })
}


export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}



export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}

export function addHuiyiFile(parameter) {
    return axios({
        url: api.addHuiyiFile,
        method: 'post',
        data: parameter
    })
}

export function getHuiyiFileList(parameter) {
    return axios({
        url: api.huiyiFileList,
        method: 'get',
        params: parameter
    })
}

export function deleteHuiyiFile(parameter) {
    return axios({
        url: api.deleteHuiyiFile,
        method: 'post',
        data: parameter
    })
}


export function getServiceTypeList(parameter) {
    return axios({
        url: api.serviceTypeList,
        method: 'get',
        params: parameter
    })
}


export function addServiceType(parameter) {
    return axios({
        url: api.addServiceType,
        method: 'post',
        data: parameter
    })
}

export function editServiceType(parameter) {
    return axios({
        url: api.editServiceType,
        method: 'post',
        data: parameter
    })
}
export function getServiceTypeDetail(parameter) {
    return axios({
        url: api.serviceTypeDetail,
        method: 'get',
        params: parameter
    })
}

export function serviceTypeDelete(parameter) {
    return axios({
        url: api.serviceTypeDelete,
        method: 'post',
        data: parameter
    })
}



export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}
export function deleteApply(parameter) {
    return axios({
        url: api.deleteApply,
        method: 'get',
        params: parameter
    })
}

export function getApplyMemberList(parameter) {
    return axios({
        url: api.applyMemberList,
        method: 'get',
        params: parameter
    })
}

export function getApplyMemberDetail(parameter) {
    return axios({
        url: api.applyMemberDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplyMember(parameter) {
    return axios({
        url: api.editApplyMember,
        method: 'post',
        data: parameter
    })
}
export function editApplyMemberScore(parameter) {
    return axios({
        url: api.editApplyMemberScore,
        method: 'post',
        data: parameter
    })
}
export function scoreImport(parameter) {
    return axios({
        url: api.scoreImport,
        method: 'post',
        data: parameter
    })
}
export function deleteApplyMember(parameter) {
    return axios({
        url: api.deleteApplyMember,
        method: 'get',
        params: parameter
    })
}

export function sjsqOptions(parameter) {
    return axios({
        url: api.sjsqOptions,
        method: 'get',
        params: parameter
    })
}

